import {Asset} from "../../entities/Asset";
import {AssetService} from "../../services/AssetService";
import { NotificationService } from "../../services/NotificationService";
import { ServerImportModel } from "./ServerImportModel";

export class ServerAssetImportModel extends ServerImportModel<Asset>  {
    static $inject = ['$q', 'AssetService', 'NotificationService', '$timeout'];
    name:string = "test";
    importType:string = "Asset";

    constructor($q: ng.IQService, public assetService: AssetService, public notifyService: NotificationService, public timeout: ng.ITimeoutService){
        super($q,assetService, notifyService, timeout);
    }
    getRoute(nextAction:string):string{
        return "admin.serverassetimport."+nextAction;
    }
    getControllersName(): string {
        return "assets";
    }
}
